<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAttachments } from './composables';
import 'viewerjs/dist/viewer.css';
import { component as Viewer } from 'v-viewer';

const props = defineProps({
  record: {
    type: Object,
    default: () => ({}),
  }
});

const attachmentTitle = computed(() => props.record.title);
const attachmentURLs = computed(() => props.record.attachmentURLs || []);
const attachments = computed(() => props.record.attachments?.flatMap((a) => a.url) || []);
const description = computed(() => props.record.description);
const attachmentsFinal = computed(() => [...attachments.value, ...attachmentURLs.value]);

const viewer = ref(null);
const inited = (viewer) => {
  viewer.value = viewer;
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <p v-if="attachmentTitle" class="text-sm font-medium">{{ attachmentTitle }}</p>
    <Viewer 
      :images="attachmentsFinal" 
      @inited="inited" 
      class="viewer flex flex-row flex-wrap gap-4" 
      ref="viewer"
    >
      <template #default="scope">
        <div v-for="src in scope.images" :key="src">
          <img 
            :src="src" 
            :key="src" 
            class="max-w-[100px] max-h-[100px] hover:cursor-pointer hover:shadow-sm rounded-lg" 
          />
        </div>
      </template>
    </Viewer>
    <div v-if="description" class="flex flex-col gap-2">
      <span class="text-sm font-semibold">Description:</span>
      <span class="text-sm text-neutral-500">{{ description }}</span>
    </div>
  </div>
</template>